<template>
  <div class="g-my-sort-box u-group" :data-sort="value" @click="changeSort">
    <i class="u-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path d="M8.5,2H.5a.5.5,0,0,0,0,1h8a.5.5,0,0,0,0-1Z" fill="#1a1a1a"></path>
        <path d="M8.5,7H.5a.5.5,0,0,0,0,1h8a.5.5,0,0,0,0-1Z" fill="#1a1a1a"></path>
        <path d="M8.5,12H.5a.5.5,0,0,0,0,1h8a.5.5,0,0,0,0-1Z" fill="#1a1a1a"></path>
        <path d="M15.85,6.15,11.94,2.24s0,0,0,0A.49.49,0,0,0,11.5,2a.5.5,0,0,0-.5.5v10a.5.5,0,0,0,1,0V3.71l3.15,3.14a.48.48,0,0,0,.7,0A.48.48,0,0,0,15.85,6.15Z" fill="#1a1a1a"></path>
      </svg>
    </i>
    <span class="u-sn" v-if="value === 'desc'">{{$t('components_my_sort_index_2451')}}</span>
    <span class="u-sn" v-if="value === 'asc'">{{$t('components_my_sort_index_2452')}}</span>
  </div>
</template>

<script>
import i18n from '../../language/index'

  export default {
    name: 'my_sort',
    components: {}, // 注册组件
    directives: {},
    props: {
      value: {
        type: String,
        default: 'desc'
      }
    },
    data () {
      return {
        formInline: {
          channelName: '',
          page: {
            total: 0,
            pageSize: 10,
            currentPage: 1
          }
        },
        filter: {
          listingNameOptions: []
        },
        tableTile: [],
        loading: true,
        tableData: []
      }
    },
    computed: {}, // 计算属性
    watch: {},
    beforeCreate () {},
    created () {},
    mounted () {},
    beforeUpdate () {},
    beforeDestroy () {},
    methods: {
      changeSort () {
        if (this.value === 'asc') {
          this.$emit('input', 'desc')
        } else {
          this.$emit('input', 'asc')
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .g-my-sort-box {
    &.u-group {
      display: flex;
      height: 32px;
      margin-left: 20px;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .u-icon {
        margin-right: 5px;
        width: 16px;
        height: 16px;
        transition: transform ease-in-out .3s,-webkit-transform ease-in-out .3s,-moz-transform ease-in-out .3s,-o-transform ease-in-out .3s;
      }
      &[data-sort='des'] .u-icon {
        transform: rotateX(180deg);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/my_sort/index.vue